module.exports = __webpack_public_path__ + "img/pc_nav_bg.949e18e.webp";